module.exports = __webpack_public_path__ + "media/images/new_home/our-purpose-f9054dc4fa19cb5f6cbe8528867bd4be.png";